

import CandidateVisit from './candidate-visits';


const CandidateVisits = new CandidateVisit();

export {
    CandidateVisits,
}